export const educationData = [
  {
    degree: "BSc (Hons) in Computer Engineering",
    institution: "University of Jaffna",
    year: "2022 - 2026",
    details: "GPA: 3.07"
  },
  {
    degree: "Advanced Level – Physical Science Stream",
    institution: "Badulla Central College",
      year: "2018 - 2020",
    details : "B-Physics, A-Chemistry, A-Combined Mathematics"
  },
  {
    degree: "Ordinary Level",
    institution: "Uva Science College",
    year: "2012 - 2017"
  },
  {
    degree: "Primary Education",
    institution: "Dharmathutha College",
    year: "2006 - 2011"
  }
];
